export default __webpack_public_path__ + "2a3434ad7495927a1af2959e2faba4e5.svg";